"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gyropolis = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const TileType_1 = require("../../TileType");
class Gyropolis extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.GYROPOLIS,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.BUILDING],
            cost: 20,
            metadata: {
                cardNumber: '230',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => {
                        pb.minus().energy(2).br;
                        pb.plus().megacredits(1).slash().venus(1).played.br;
                        pb.plus().megacredits(1).slash().earth().played.br;
                    }).nbsp().city();
                }),
                description: 'Decrease your energy production 2 steps. Increase your M€ production 1 step for each Venus and Earth tag you have. Place a City tile.',
            },
        });
    }
    ;
    canPlay(player) {
        if (player.game.board.getAvailableSpacesForCity(player).length === 0)
            return false;
        return player.getProduction(Resources_1.Resources.ENERGY) >= 2;
    }
    produce(player) {
        const tags = [Tags_1.Tags.VENUS, Tags_1.Tags.EARTH];
        player.addProduction(Resources_1.Resources.ENERGY, -2);
        player.addProduction(Resources_1.Resources.MEGACREDITS, player.getMultipleTagCount(tags, 'milestones'), { log: true });
    }
    play(player) {
        this.produce(player);
        return new SelectSpace_1.SelectSpace('Select space for city tile', player.game.board.getAvailableSpacesForCity(player), TileType_1.TileType.CITY, (space) => {
            player.game.addCityTile(player, space.id);
            return undefined;
        });
    }
}
exports.Gyropolis = Gyropolis;
//# sourceMappingURL=Gyropolis.js.map